const EMPTY_VALUE = "";

const getValue = (value) =>
  value === null || value === undefined || value === ""
    ? EMPTY_VALUE
    : value;

const formatPhoneWithCode = (code, phone) => {
  if (!phone) return EMPTY_VALUE;
  if (!code) return phone;
  const cleanCode = typeof code === "object" ? code.code : code;
  return `${cleanCode} ${phone}`;
};

const formatPreferredContactMethod = (method) => {
  if (method === null || method === undefined || method === "") return EMPTY_VALUE;
  if (Array.isArray(method)) {
    return (
      method
        .map((item) => {
          if (!item) return "";
          if (typeof item === "object") {
            return item?.methodType || item?.contactMethod || item?.name || "";
          }
          return String(item).trim();
        })
        .filter(Boolean)
        .join(", ") || EMPTY_VALUE
    );
  }
  if (typeof method === "object") {
    return method?.methodType || method?.contactMethod || method?.name || EMPTY_VALUE;
  }
  if (typeof method === "string") {
    const trimmed = method.trim();
    if (trimmed.startsWith("[") && trimmed.endsWith("]")) {
      try {
        const parsed = JSON.parse(trimmed);
        if (Array.isArray(parsed)) {
          return parsed.join(", ");
        }
      } catch {
        // ignore
      }
    }
    return trimmed;
  }
  return String(method);
};

export const getProspectContactCommunicationView = (data = {}) => {
  const left = [
    {
      label: "Office Phone",
      value: formatPhoneWithCode(data?.dialingCodePhone, data?.phone),
    },
    {
      label: "Source Name",
      value: getValue(
        typeof data?.sourceName === "object"
          ? data?.sourceName?.source || data?.sourceName?.sourceName
          : data?.sourceName,
      ),
    },

    {
      label: "Country",
      value: getValue(
        typeof data?.country === "object" ? data?.country?.name : data?.country,
      ),
    },
    {
      label: "City",
      value: getValue(data?.city),
    },
  ];

  const right = [

    {
      label: "Mobile",
      value: formatPhoneWithCode(data?.dialingCodeMobile, data?.mobile),
    },
    {
      label: "Preferred Language",
      value: getValue(
        typeof data?.preferredLanguage === "object"
          ? data?.preferredLanguage?.preferredLanguageName
          : data?.preferredLanguage,
      ),
    },
    {
      label: "State",
      value: getValue(
        typeof data?.state === "object" ? data?.state?.name : data?.state,
      ),
    },
    {
      label: "Timezone",
      value: getValue(
        typeof data?.timezone === "object"
          ? `${data?.timezone?.name || ""}${data?.timezone?.utcOffsetStr ? ` + ${data?.timezone?.utcOffsetStr}` : ""}`
          : data?.timezone,
      ),
    },
  ];

  const fullWidth = [
    {
      label: "Email",
      value: getValue(data?.email),
    },
    {
      label: "Alternate Email",
      value: getValue(data?.alternateEmail),
    },
    {
      label: "Preferred Contact",
      value: formatPreferredContactMethod(data?.preferredContactMethod),
    },
    {
      label: "Source URL",
      value: getValue(data?.sourceDetailURL),
    },
  ];

  return {
    left,
    right,
    fullWidth,
  };
};
